// extracted by mini-css-extract-plugin
export default {"code-input":"sort-code-input_code-input__iqQtL","code-input__divider":"sort-code-input_code-input__divider__FKxn-","code-input--error":"sort-code-input_code-input--error__cFbkv"};